/** @format */
import {PointName} from 'components/charts/multiline-chart/model/common';

import {generateGraphPointName} from 'helpers/miscHelpers';

import {GraphComplexValuesList} from '../../models/common';

const filterGraphComplexValues = (
  list: GraphComplexValuesList,
  rechartsDates: string[],
): GraphComplexValuesList => {
  if (!rechartsDates.length) {
    return {};
  }

  const allPoints = Object.keys(list) as PointName[];
  const discreteSet = new Set(rechartsDates);
  const result: GraphComplexValuesList = {};

  allPoints.forEach(pointName => {
    const date = list[pointName].date;
    if (discreteSet.has(date)) {
      const length = Object.keys(result).length;
      const newPointName = generateGraphPointName(length);
      result[newPointName] = list[pointName];
    }
  });

  return result;
};

export {filterGraphComplexValues};
